import { Box, LinearProgress } from "@mui/material";
import {
  DataGrid,
  GridCallbackDetails,
  GridColDef,
  GridOverlay,
  GridRowClassNameParams,
  GridRowParams,
  GridRowSelectionModel,
  GridValidRowModel,
} from "@mui/x-data-grid";
import { useState } from "react";

export interface CustomTableProps {
  rows: GridValidRowModel[];
  cols: GridColDef[];
  handleOnRowClick?: (params: GridRowParams) => void;
  isLoading: boolean;
  overlayText: string;
  getCustomRowClass?: (params: GridRowClassNameParams) => string;
  checkboxSelection?: boolean;
  onSelectionModelChange?: (
    selectionModel: GridRowSelectionModel,
    details: GridCallbackDetails
  ) => void;
  isRowSelectable?: any;
}

const CustomTable = ({
  rows,
  cols,
  handleOnRowClick,
  isLoading,
  overlayText: OverlayText,
  getCustomRowClass,
  checkboxSelection,
  onSelectionModelChange,
  isRowSelectable,
}: CustomTableProps) => {
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const LoadingOverlay = () => {
    return (
      <GridOverlay>
        <div style={{ position: "absolute", top: 0, width: "100%" }}>
          <LinearProgress />
        </div>
      </GridOverlay>
    );
  };

  const NoDataOverlay = () => {
    return (
      <GridOverlay style={{ zIndex: 5 }}>
        <Box>
          <Box>{OverlayText}</Box>
        </Box>
      </GridOverlay>
    );
  };

  return (
    <>
      <DataGrid
        checkboxSelection={checkboxSelection}
        onRowClick={handleOnRowClick}
        components={{
          LoadingOverlay: LoadingOverlay,
          NoRowsOverlay: NoDataOverlay,
        }}
        getRowClassName={getCustomRowClass ? getCustomRowClass : undefined}
        loading={isLoading}
        columns={cols}
        rows={rows}
        autoHeight={true}
        pageSizeOptions={[10, 25, 50, 100]}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        onRowSelectionModelChange={onSelectionModelChange}
        disableRowSelectionOnClick
        isRowSelectable={isRowSelectable}
        pagination
      />
    </>
  );
};

export default CustomTable;
